<template>
  <div id="intro">

    <!-- title-box -->
    <div class="title-box">
      <div class="logo-box">
        <span>M</span>
        <span>E</span>
        <span>G</span>
        <span>A</span>
        <span>B</span>
        <span>O</span>
        <span>X</span>
        <span>H</span>
        <span>O</span>
        <span>M</span>
        <span>E</span>
      </div>

      <h3>내집을 영화관처럼</h3>
    </div>


    <!-- Bar -->
    <div class="bar"></div>

  </div>
</template>

<script>
export default {
  name: "Intro",
  mounted(){ // 이 컴포넌트가 작동이되면 페이지가 넘어가게 하는설정 일정시간 지나면 넘어가는 설정
    this.homeMove(); // 장착되었을때
  },
  methods: {
    homeMove(){ // 함수설정
      // setInterval(함수,호출시간) 일정시간 게속 호출하는 함수
      // setTimeout(함수,호출시간) 일정시간 호출하고 종료하고 싶을때 사용
      setTimeout(()=>{ // function => 같은 문법 () =>
        this.$router.push('/login'); // $router 라우터 설정에서 push() 이동시키는 함수"로그인페이지로 이동"
      }, 5000);
    }
  }

}
</script>

<style lang="scss" scoped>

  #intro{ 
    position: relative; 
  }


</style>


// WEBPACK FOOTER //
// src/components/Intro.vue